import { useTranslation } from 'react-i18next'

const FilterToggleButton = ({
  visible,
  active,
  onToggle
}) => {

const { t } = useTranslation()

const baseBackground =
visible ? '#2da9a4' : (active ? '#3BC6C4' : '#f5f5f5')

return (
<button
onMouseEnter={(e) => {
e.currentTarget.style.background = '#2da9a4'
}}
onMouseLeave={(e) => {
e.currentTarget.style.background = baseBackground
e.currentTarget.style.transform = 'scale(1)'
e.currentTarget.style.boxShadow = active
? '0 2px 18px rgba(16,124,107,0.65), 0 0 6px rgba(16,124,107,0.55)'
: '0 1px 8px rgba(0,0,0,0.30)'
}}
onMouseDown={(e) => {
e.currentTarget.style.transform = 'scale(0.96)'
e.currentTarget.style.boxShadow = '0 0px 4px rgba(0,0,0,0.25)'
}}
onMouseUp={(e) => {
e.currentTarget.style.transform = 'scale(1)'
e.currentTarget.style.boxShadow = active
? '0 2px 10px rgba(165,232,195,0.95)'
: '0 1px 8px rgba(0,0,0,0.30)'
}}
onClick={onToggle}
style={{
background: baseBackground,
border: '1px solid #107c6b',
borderRadius: 6,
height: 24,
padding: '0 10px',
cursor: 'pointer',
fontWeight: 700,
boxShadow: active
? '0 2px 18px rgba(16,124,107,0.65), 0 0 6px rgba(16,124,107,0.55)'
: '0 1px 8px rgba(0,0,0,0.30)',
transition: 'transform 0.05s ease, box-shadow 0.1s ease',
marginTop: 5
}}
>
{t('TRIPLOG.FILTER')}
</button>
)
}

export default FilterToggleButton